import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import moment from "moment";
import { useSelector } from "react-redux";
import { AddCircle, Trash } from "iconsax-react";
import * as utils from "../../Utils/comman";
import CustomPagination from "../../Utils/CustomPagination";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Search } from "@mui/icons-material";
import Select from "react-select";

function List(props) {
  const [batchList, setBatchList] = useState({ result: [], total: 0 });
  const [plantList, setPlantList] = useState([]);
  const [page, setPage] = useState(1);
  const countPerPage = 10;
  const [product, setProduct] = useState([]);
  const [productName, setProductName] = useState(null);
  const [batchNo, setBatchNo] = useState("");
  // const [productName, setProductName] = useState("");
  const [plantName, setPlantName] = useState("");
  const [plantLocation, setPlantLocation] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [search, setSearch] = useState("");
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions,
  );

  const handleAddClick = () => {
    props.onChange({ mode: "add" });
  };

  const getPlantList = () => {
    utils
      .callAPI("get", "/purchaseorder/plant/list")
      .then((res) => {
        if (typeof res !== "undefined") {
          setPlantList(res?.result);
        } else {
          setPlantList([]);
        }
      })
      .catch(() => {
        setPlantList([]);
      });
  };

  const getBatchList = () => {
    setBatchList((prevState) => ({
      ...prevState,
      result: [],
    }));
    const fromDate = startDate ? moment(startDate).format("YYYY-MM-DD") : "";
    const toDate = endDate ? moment(endDate).format("YYYY-MM-DD") : "";

    let query = `page=${page}&per_page=${countPerPage}`;
    if (batchNo) query += `&batch_no=${batchNo}`;
    if (productName) query += `&product_id=${productName}`;
    if (plantLocation) query += `&plant_id=${plantLocation}`;
    if (startDate) query += `&from_date=${fromDate}`;
    if (endDate) query += `&to_date=${toDate}`;

    utils
      .callAPI("get", `production/batch/list?${query}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setBatchList({
            result: res.result,
            total: res.total || 0,
          });
          setSearch("");
        } else {
          setBatchList({ result: [], total: 0 });
        }
      })
      .catch(() => {
        setBatchList({ result: [], total: 0 });

        setSearch("");
      });
  };

  useEffect(() => {
    getBatchList();
  }, [page]);

  useEffect(() => {
    getPlantList();
    getproduct();
  }, []);

  const getproduct = () => {
    utils
      .callAPI("get", `/Product/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setProduct(res?.result);
        } else {
          setProduct([]);
        }
      })
      .catch((err) => {
        setProduct([]);
      });
  };
  const showDelete = useCallback(
    (row) => async () => {
      Swal.fire({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this data!",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          utils
            .callAPI(
              "get",
              `production/batch/delete?batch_id=${row.batchId}`,
              "",
            )
            .then(() => {
              getBatchList();
            })
            .catch(() => {});
        }
      });
    },
    [],
  );

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleSearch = () => {
    setBatchList([]);
    setPage(1);
    setSearch("search");
  };

  const handleReset = () => {
    setBatchNo("");
    setPlantLocation("");
    setDateRange([null, null]);
    setPage(1);
    setProductName("");
    setSearch("reset");
  };

  useEffect(() => {
    if (search == "search" || search == "reset") {
      getBatchList();
    }
  }, [search]);

  const columns = [
    {
      name: <>Batch No.</>,
      selector: (row) => row.batch_no,
    },
    {
      name: <>Product Name</>,
      selector: (row) =>
        `${row.product_name} ${row.size || ""} ${row.unit?.toUpperCase() || ""}`.trim(),
    },
    {
      name: <>Plant Location/Code</>,
      selector: (row) => row.plant_name,
    },
    {
      name: <>Batch Size</>,
      selector: (row) => row.plant_batch_size,
    },
    {
      name: <>Date</>,
      selector: (row) => moment(row.createdAt).format("DD-MM-YYYY hh:mm A"),
    },
    {
      name: <>Action</>,
      center: true,
      cell: (row) =>
        utils.hasPermission(
          primaryMenuRes,
          "Batch Creation",
          "batch_creation.delete",
        ) && (
          <RB.Button className="btn btn-flat ms-1" onClick={showDelete(row)}>
            <Trash />
          </RB.Button>
        ),
    },
  ];

  const productOptions = product.map((p) => ({
    value: p.id,
    label: `${p.product_name} - ${p?.size} ${p?.unit?.toUpperCase() || ""}`,
  }));

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header>
          <div className="floating-btns-holder-artisan">
            {utils.hasPermission(
              primaryMenuRes,
              "Batch Creation",
              "batch_creation.create",
            ) && (
              <RB.Button
                className="btn btn-dark btn-circle"
                variant="dark"
                onClick={handleAddClick}
              >
                <AddCircle />
              </RB.Button>
            )}
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          {/* Filter Section */}
          {utils.hasPermission(
            primaryMenuRes,
            "Batch Creation",
            "batch_creation.view",
          ) && (
            <>
              <RB.Row className="mb-3">
                <RB.Col md={2} className="mt-2">
                  <RB.Form.Control
                    type="text"
                    placeholder="Batch No"
                    value={batchNo}
                    onChange={(e) => setBatchNo(e.target.value)}
                  />
                </RB.Col>
                <RB.Col md={3} className="mt-2">
                  <Select
                    options={productOptions}
                    value={
                      productName
                        ? productOptions.find(
                            (opt) => opt.value === productName,
                          )
                        : null
                    }
                    onChange={(selectedOption) =>
                      setProductName(
                        selectedOption ? selectedOption.value : null,
                      )
                    }
                    placeholder="Select Product Name"
                    isSearchable
                    isClearable
                  />
                </RB.Col>

                <RB.Col md={2} className="mt-2">
                  <RB.Form.Select
                    value={plantLocation}
                    onChange={(e) => setPlantLocation(e.target.value)}
                  >
                    <option value="">Plant Location</option>
                    {plantList.map((plant) => (
                      <option key={plant.id} value={plant.id}>
                        {plant.plant_name}
                      </option>
                    ))}
                  </RB.Form.Select>
                </RB.Col>
                <RB.Col md={3} className="mt-2">
                  <DatePicker
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                      setDateRange(update);
                    }}
                    isClearable
                    placeholderText="Select Date Range"
                    className="form-control"
                    dateFormat="yyyy-MM-dd"
                  />
                </RB.Col>

                <RB.Col md="2" className="mt-2">
                  <RB.Button
                    variant="primary"
                    className="me-2"
                    onClick={handleSearch}
                  >
                    Search
                  </RB.Button>
                  <RB.Button variant="secondary" onClick={handleReset}>
                    Reset
                  </RB.Button>
                </RB.Col>
              </RB.Row>

              <DataTable
                columns={columns}
                data={batchList?.result || []}
                highlightOnHover
                responsive
                pagination
                paginationServer
                paginationTotalRows={batchList.total}
                paginationPerPage={countPerPage}
                paginationComponentOptions={{ noRowsPerPage: true }}
                paginationComponent={() => (
                  <CustomPagination
                    currentPage={page}
                    totalRows={batchList.total}
                    rowsPerPage={countPerPage}
                    onPageChange={handlePageChange}
                  />
                )}
                persistTableHead
                customStyles={{
                  head: {
                    style: {
                      fontSize: "0.875rem",
                      fontWeight: "bold",
                    },
                  },
                }}
                striped
              />
            </>
          )}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default List;
